import styled from 'styled-components';

import {
  Header as TextHeader,
  Segment as SegmentLayoutComponent,
  Checkbox as LayoutCheckbox,
} from '@playbookux/playbook-web-core';
import LayoutDivider from '../../../../core/layout-components/divider';

export const Header = styled.div`
  display: flex;
  margin-bottom: 5px;
  justify-content: space-between;
  flex-direction: column;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const Card = styled(SegmentLayoutComponent)`
  &&& {
    padding: 20px;
    width: 100%;
  }
`;

const CardHeader = styled(Header)`
  flex-direction: row;
`;

const Text = styled(TextHeader)``;

const Checkbox = styled(LayoutCheckbox)`
    &&&.ui.checkbox label{
    color: ${({ theme }) => theme.color.textSecondary}
  }
`;

const Divider = styled(LayoutDivider)`
  &&&& {
    margin: 0;
  }
`;

const RowContentContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  margin-left: 20px;
`;

const CheckboxTag = styled(LayoutCheckbox)`
  &&&.ui.checkbox label{
    color: ${({ theme }) => theme.color.textSecondary}
  }

  &&&.ui.checkbox input:checked~label:before{
    background: ${({ color }) => color || '#E1E1E1'};
  }
`;

const IconLabel = styled.img`
  height: 15px;
  width: auto;
  margin-right: 5px;
  vertical-align: middle;
`;

const FilterLabel = styled.label``;

export {
  Card,
  CardHeader,
  Container,
  Text,
  Checkbox,
  Divider,
  CheckboxTag,
  RowContentContainer,
  IconLabel,
  FilterLabel,
};
